/**
 * Promo desktop swiper: move nav into products column and isolate slide changes.
 */
(function () {
  const DESKTOP_HOST_SELECTOR =
    '.collection-section__promo-swiper-host--desktop';
  const DESKTOP_MQ = window.matchMedia('(min-width: 1024px)');

  function syncPromoDesktopSlides(host) {
    const slides = host.querySelectorAll('.swiper-slide');
    if (!slides.length) return;

    slides.forEach((slide) => {
      const isActive = slide.classList.contains('swiper-slide-active');
      slide.setAttribute('aria-hidden', isActive ? 'false' : 'true');

      if (isActive) return;

      slide.querySelectorAll('input, button, select, textarea, a').forEach(
        (element) => {
          if (element === document.activeElement) {
            element.blur();
          }
        }
      );
    });
  }

  function repositionPromoNavigation(host) {
    const products = host.closest('.collection-section__products');
    const swiperRoot = host.querySelector('[data-swiper-slideshow]');
    const nav = swiperRoot?.querySelector('.swiper-slideshow__navigation');
    if (!nav || !products || nav.dataset.promoNavMoved === 'true') return false;

    products.appendChild(nav);
    nav.classList.add('collection-section__promo-nav--desktop');
    nav.dataset.promoNavMoved = 'true';
    host.classList.add('collection-section__promo-swiper-host--nav-ready');
    return true;
  }

  function refreshPromoDesktopSwiper(host, swiper) {
    if (!swiper || !DESKTOP_MQ.matches) return;
    if (host.offsetParent === null) return;

    const activeIndex = swiper.activeIndex;
    swiper.update();
    swiper.slideTo(activeIndex, 0, false);
    syncPromoDesktopSlides(host);
  }

  function bindPromoDesktopResize(host) {
    if (host.dataset.promoResizeBound === 'true') return;
    host.dataset.promoResizeBound = 'true';

    let resizeTimer;
    const onResize = () => {
      clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(() => {
        refreshPromoDesktopSwiper(host, host.getSwiper?.());
      }, 150);
    };

    window.addEventListener('resize', onResize);

    DESKTOP_MQ.addEventListener('change', () => {
      window.setTimeout(() => {
        refreshPromoDesktopSwiper(host, host.getSwiper?.());
      }, 50);
    });

    const products = host.closest('.collection-section__products');
    if (products && typeof ResizeObserver !== 'undefined') {
      const ro = new ResizeObserver(onResize);
      ro.observe(products);
    }
  }

  function bindSwiperInstance(host, swiper) {
    if (!swiper || swiper.__promoDesktopBound) return;
    swiper.__promoDesktopBound = true;

    swiper.on('slideChangeTransitionStart', () => {
      syncPromoDesktopSlides(host);
    });
    swiper.on('slideChangeTransitionEnd', () => {
      syncPromoDesktopSlides(host);
    });
    swiper.on('slideChange', () => {
      syncPromoDesktopSlides(host);
    });

    bindPromoDesktopResize(host);
    syncPromoDesktopSlides(host);
  }

  function bindPromoDesktopHost(host) {
    if (host.dataset.promoDesktopBound === 'true') return;
    host.dataset.promoDesktopBound = 'true';

    host.addEventListener('swiper:slideChange', () => {
      syncPromoDesktopSlides(host);
    });

    const waitForSwiper = (attempts = 0) => {
      const swiper = host.getSwiper?.();
      if (swiper) {
        repositionPromoNavigation(host);
        bindSwiperInstance(host, swiper);
        refreshPromoDesktopSwiper(host, swiper);
        return;
      }

      if (attempts < 40) {
        window.setTimeout(() => waitForSwiper(attempts + 1), 50);
      }
    };

    waitForSwiper();
  }

  function initPromoDesktopSlideshows(root = document) {
    root.querySelectorAll(DESKTOP_HOST_SELECTOR).forEach(bindPromoDesktopHost);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () =>
      initPromoDesktopSlideshows()
    );
  } else {
    initPromoDesktopSlideshows();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initPromoDesktopSlideshows(event.target);
  });
})();
